import React, {
  useState,
  useEffect
} from 'react'
import {
  Form,
  Input
} from 'antd';
const { TextArea } = Input;

export const Text = props => {

  const form = Form.useFormInstance()
  const [ formContext, setFormContext ] = useState()

  const required = props.parent.attribs['data-required'] == 'true'
  
  useEffect(() => {

    if(form) {
      
      setFormContext(form)
    }

  }, [form])

  return <div className="wp-block-playmotivcloud-surveyanswer text">
    <Form.Item
      name={ props.parent.attribs['data-blockid'] }
      rules={[{ required: required, message: "Este campo es obligatorio" }]}
    >
      <TextArea 
        rows={4}
        disabled={ formContext?.eventData?.instance.closed }
      />
    </Form.Item>
  </div>
}